<template>
  <div v-if="!allSitesLoaded" class="item-count">
    Loading sites: <span>{{ pagesLoaded }}</span>/{{ totalPages }}
  </div>
  <div v-else class="all-items-loaded">
    <span>All sites loaded</span>
  </div>
</template>

<script>
export default {
  name: "sites-loading-progress",

  computed: {
    pagesLoaded() {
      return this.$store.getters.sitesPagesLoaded * 25;
    },
    totalPages() {
      const totalPages = this.$store.getters.sitesTotalPages;
      return totalPages > 0 ? totalPages * 25 : "?";
    },
    allSitesLoaded() {
      const pagesLoaded = this.$store.getters.sitesPagesLoaded;
      return pagesLoaded > 0 && pagesLoaded === this.$store.getters.sitesTotalPages;
    },
  },
};
</script>